import React, { useReducer } from 'react'
import { Container, Row, Col, Card, Image } from 'react-bootstrap'


export function Valikko() {
	const [state, dispatch] = useReducer(reducer, {},  initState)
	console.log(state)
return (
	<Container fluid style={{'maxWidth': '1100px'}}>
	<Row>
	<Selection state={state.warmup} dispatch={(e) => dispatch({type: 'warmup', payload: e})} title='Lämmittely' cards={warmup} />
	<Selection state={state.exercise} dispatch={(e) => dispatch({type: 'exercise', payload: e})} title='Harjoite' cards={exercise}  />
	<Selection state={state.cooldown} dispatch={(e) => dispatch({type: 'cooldown', payload: e})} title='Jäähdyttely' cards={cooldown}  />
	</Row>
	</Container>
)
}

export const warmup = [
	{ 'id': 1, 'title': 'Metsäretki', 'image': 'images/forest-1.png'},
	{ 'id': 2, 'title': 'Kuusimetsä', 'image': 'images/forest-2.png'},
	{ 'id': 3, 'title': 'Eväsretki', 'image': 'images/forest-3.png'},
	{ 'id': 4, 'title': 'Mäntymetsä', 'image': 'images/forest-4.png'},
]

export const exercise = [
	{ 'id': 5, 'title': 'Huvipuisto', 'image': 'images/park-1.png'},
	{ 'id': 6, 'title': 'Karuselli', 'image': 'images/park-2.png'},
	{ 'id': 7, 'title': 'Aurinkoranta', 'image': 'images/beach-3.png'},
	{ 'id': 8, 'title': 'Rantaleikit', 'image': 'images/beach-4.png'},
]

export const cooldown = [
	{ 'id': 9, 'title': 'Aurinkovarjo', 'image': 'images/beach-1.png'},
	{ 'id': 10, 'title': 'Palmu', 'image': 'images/beach-2.png'},
	{ 'id': 11, 'title': 'Mäntymetsä', 'image': 'images/forest-4.png'},
	{ 'id': 12, 'title': 'Kuusimetsä', 'image': 'images/forest-2.png'},
]


export function Selection({state, dispatch, title, cards}) {
return (
	<Col xs={12}>
	<Card style={{'margin':'1rem'}}>
	<Card.Header>{title}</Card.Header>
	<Card.Body   style={{'textAlign': 'left'}}>
	<Container>
	<Row>
	{cards.map((card, idx) => {
		const style = state !== card.id ? 
			{ boxShadow: '3px 5px 6px rgba(0,0,0,0.5)'} : 
			{ borderColor: 'rgba(250,0,0,0.9)' }  
		console.log(style);
		return( 
			<Col key={idx} xs={3} onClick={() => dispatch(card.id)}>
				<Card style={style}> 
				<Card.Header>{card.title}</Card.Header>
				<Card.Body>
				<Image src={card.image} width='128' height='128' rounded />		
				</Card.Body>
				</Card>
			</Col>
		)}
	)}
	</Row>
	</Container>
	</Card.Body>
	</Card>
	</Col>
)
}



export function initState() {
	return {
		warmup: null,
		exercise: null,
		cooldown: null,
	}
}

export function reducer(state, action) {
	console.log('valikko_reducer', state, action)
	const newState = { ...state }
	switch(action.type) {
		case 'warmup':
			newState.warmup = action.payload
			break
		case 'exercise':
			newState.exercise = action.payload
			break
		case 'cooldown':
			newState.cooldown = action.payload
			break
		default:
			return state
	}
	return newState	
}